<template>
  <component
    :is="illustration"
    :style="illustrationStyles"
  />
</template>

<script>

export default {
  name: 'SnIllustration',
  props: {
    illustration: {
      type: String,
      required: true
    },
    primaryColor: {
      type: String,
      default: 'snPrimary'
    },
    secondaryColor: {
      type: String,
      default: 'snBrand'
    }
  },
  computed: {
    primaryColorHex () {
      return this.getColorHex(this.primaryColor)
    },
    secondaryColorHex () {
      return this.getColorHex(this.secondaryColor)
    },
    illustrationStyles () {
      var styles = {}
      if (this.primaryColorHex) { styles['--primary-color'] = this.primaryColorHex }
      if (this.secondaryColorHex) { styles['--secondary-color'] = this.secondaryColorHex }
      return styles
    }
  },
  watch: {
    illustration (val) {
      this.$options.components[val] = require(`./illustrations/${val}.vue`).default
    }
  },
  created () {
    this.$options.components[this.illustration] = require(`./illustrations/${this.illustration}.vue`).default
  },
  methods: {
    getColorHex (color) {
      if (!color) { return null }
      if (!this.$vuetify?.theme?.themes?.light) { return null }
      var colorHex = this.$vuetify.theme.themes.light[color]
      if (!colorHex) { return null }
      return colorHex
    }
  }
}
</script>

<style scoped lang="scss">
@import '~/assets/css/snui';
</style>
